import { HUBSPOT_VIDEO_FEEDBACK_EVENTS } from '@/shared/thirdParty/hubSpot';
import { OPTIONS } from '../constants';
import { FormValues } from '../types';

export const getHubSpotEventKey = (options: FormValues['options']) => {
  const optionIndex = options.findIndex((option) => option);
  return optionIndex < 0 ? HUBSPOT_VIDEO_FEEDBACK_EVENTS.negativeFeedback : OPTIONS[optionIndex].hubSpotEvent;
};
